<script lang="typescript">
  // components
  import ResultsTable from './ResultsTable.svelte';
  import ResultsMap from './Temp.svelte';

  // stores
  import { createCandidateLookup, createSubunitLookup } from '../stores/state';

  // types
  import type { FeatureCollection } from 'geojson';
  import type { Readable } from 'svelte/store';
  import type { RaceInterface } from '../interfaces';

  // props
  export let race: Readable<RaceInterface>;
  export let geography: FeatureCollection;
  export let roads: FeatureCollection;
  export let cities: FeatureCollection;

  // private
  $: candidates = createCandidateLookup(race);
  $: subunits = createSubunitLookup(race);
  $: caption = $race.seat_number ? `District ${$race.seat_number}` : $race.name;
</script>

<ResultsTable
  {caption}
  candidates={$race.candidates}
  totalVotes={$race.total_votes}
  precinctsReportingPercent={$race.precincts_reporting_percent}
  eevp={$race.eevp} />
<div class="statemap display-flex justify-center flex-wrap">
  <ResultsMap {geography} {roads} {cities} {candidates} {subunits} />
  <div class="legend-holder">
    <div class="party-key"><span class="key-color d-win" /> Dem. lead</div>
    <div class="party-key"><span class="key-color r-win" /> Rep. lead</div>
    <div class="party-key"><span class="key-color tie-win" /> Tie</div>
    <div class="party-key"><span class="key-color n-win" /> No results</div>
  </div>
</div>
